export function renderNumberFieldFormFieldTemplate({
  indent,
  fieldName,
  formItemProps,
  labelWithDescription,
  fieldType,
  stepProp,
  toLowerCase,
  emptyValue,
  applyDefaultValueFrom
}: {
  indent: string
  fieldName: string
  formItemProps: string
  labelWithDescription: string
  fieldType: string
  stepProp: string
  toLowerCase: string
  emptyValue: string
  applyDefaultValueFrom: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <Input
${indent}          type="${fieldType}"${stepProp}
${indent}          placeholder="Enter ${toLowerCase}"
${indent}          disabled={isPending}
${indent}          value={formField.value ?? ''}
${indent}          onChange={(event) => {
${indent}            const nextValue = event.target.value === '' ? ${emptyValue} : event.target.valueAsNumber
${indent}            const normalizedValue = Number.isNaN(nextValue) ? ${emptyValue} : nextValue
${applyDefaultValueFrom}${indent}            formField.onChange(normalizedValue)
${indent}          }}
${indent}          onBlur={formField.onBlur}
${indent}          name={formField.name}
${indent}          ref={formField.ref}
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}
